import { isNotEmpty } from "@/helpers/validators";
import { regex } from "vuelidate/lib/validators/common";
import { email } from "vuelidate/lib/validators";

/**
 * Custom validator to know if a given string separated with a delimiter is a valid Email List
 * Closure
 * @param {*} delimiter The character delimiter for the given list
 * @returns {function} Returns a function which receives a string to evaluate if it's a email list
 */
const emailList = (delimiter = ",") => {
  return function (param) {
    if (param.trim().length <= 0) return true;

    if (
      param
        .replaceAll(/\s/g, "")
        .split(";")
        .some((value) => value.length == 0).length > 0
    )
      return false;

    return param
      .split(`${delimiter}`)
      .map((value) => value.trim())
      .filter((value) => value.length > 0)
      .every(email);
  };
};

const isBooleanValue =
  (expect = true) =>
    (param) =>
      param == expect;

const alphaNumDot = regex("alpha", /^[a-zA-Z0-9.]+$/);

const cuit = () => {
  const ValidateCUITCUIL = (cuit) => {
    let rv = false;
    let resultado = 0;
    let cuitnro = cuit.replace("-", "");
    let codes = "6789456789";
    let verificador = Number.parseInt(cuitnro[cuitnro.length - 1]);
    let x = 0;

    while (x < 10) {
      let digitoValidador = Number.parseInt(codes.substring(x, x + 1));
      if (Number.isNaN(digitoValidador)) digitoValidador = 0;
      let digito = Number.parseInt(cuitnro.substring(x, x + 1));
      if (Number.isNaN(digito)) digito = 0;
      let digitoValidacion = digitoValidador * digito;
      resultado += digitoValidacion;
      x++;
    }
    resultado = resultado % 11;
    rv = resultado == verificador;
    return rv;
  };

  return function (param) {
    if (param) {
      if (param.startsWith("99-99999999-")) return true;
      if (param.startsWith("11-11111111-")) return true;
      if (param.length != 13) return false;
      if (param.split("-").filter(isNotEmpty).length != 3) return false;
      if (param.split("-").every(Number.isInteger)) return false;
      return ValidateCUITCUIL(param);
    } else {
      return true;
    }
  };
};

const fixMigImp = () => (param) => {
  if (param) {
    return !(param.includes(",") || param.includes("|"));
  } else {
    return true;
  }
};

const fixImp = () => (param) => {
  if (param) {
    return !param.includes(",");
  } else {
    return true;
  }
};

export { emailList, isBooleanValue, alphaNumDot, cuit, fixMigImp, fixImp };

export default {
  data() {
    return {
      emailList
      , isBooleanValue
      , alphaNumDot
      , cuit
      , fixMigImp
      , fixImp
    };
  }
};



// WEBPACK FOOTER //
// ./src/helpers/vuelidate/validators.js